import { createAsyncActionTypes } from '../../helpers';

const domain = 'ratings';

const addOrUpdateRating = createAsyncActionTypes(domain, 'addOrUpdateRating');
const fetchRatingsByUserId = createAsyncActionTypes(domain, 'fetchRatingsByUserId');
const changeRatingStatus = createAsyncActionTypes(domain, 'changeRatingStatus');
const deleteRating = createAsyncActionTypes(domain, 'deleteRating');
const getProjectsFeedbackData = createAsyncActionTypes(domain, 'getProjectsFeedbackData');
const getProjectsFeedbackForExcel = createAsyncActionTypes(domain, 'getProjectsFeedbackForExcel');

export default {
  addOrUpdateRating,
  fetchRatingsByUserId,
  changeRatingStatus,
  deleteRating,
  getProjectsFeedbackData,
  getProjectsFeedbackForExcel,
};
